import useMount from 'hooks/useMount';
import { useMemo, useCallback, useEffect } from 'react';
import { AMOUNT_FIELD_NAME, DEPOSIT_CONFIG } from './constants';
import { Grid } from '@mui/material';
import useTranslates from 'utils/translate';
import FormInput from 'components/common/Form/Input';

const Deposit = ({
  watch,
  control,
  setError,
  paymentMethod,
  changeAmountFieldVisibility,
  changeActionButtonVisibility,
  changeActionButtonAvailability,
}) => {
  const { translate } = useTranslates();
  const configuration = DEPOSIT_CONFIG[paymentMethod.method.name];
  const originalFieldNames = useMemo(() => Object.keys(configuration), [configuration]);
  const fieldNames = useMemo(
    () => originalFieldNames.filter((fieldName) => fieldName !== AMOUNT_FIELD_NAME),
    [configuration]
  );

  useMount(() => {
    changeAmountFieldVisibility(originalFieldNames.includes(AMOUNT_FIELD_NAME));
    changeActionButtonVisibility(true);
    changeActionButtonAvailability(false);
  });

  const validateField = useCallback((fieldName: string) => {
    const fieldValue = watch(fieldName) || '';
    const validators = configuration[fieldName];

    const validByLength = !validators?.length || fieldValue.length === validators.length;
    const validByRegexp = !validators?.regexp || validators.regexp.test(fieldValue);
    return validByLength && validByRegexp && Boolean(fieldValue);
  }, []);

  const onFieldBlur = (fieldName: string) => {
    if (validateField(fieldName)) {
      setError(fieldName, null);
    } else {
      setError(fieldName, { message: translate(`invalid_${fieldName}`) });
    }
  };

  const areAllFieldsFilled = originalFieldNames.every(validateField);

  useEffect(() => {
    changeActionButtonAvailability(areAllFieldsFilled);
  }, [areAllFieldsFilled]);

  return (
    <>
      {fieldNames.map((fieldName) => (
        <Grid item xs={24} key={fieldName}>
          <FormInput
            label={translate(fieldName)}
            name={fieldName}
            required
            control={control}
            onBlur={() => onFieldBlur(fieldName)}
          />
        </Grid>
      ))}
    </>
  );
};

export default Deposit;
